import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-office-grid',
  templateUrl: './office-grid.component.html',
  styleUrls: ['./office-grid.component.css']
})
export class OfficeGridComponent implements OnInit {

  title ="Office List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/office/office-grid/office-grid.component.ts